import "what-input";
import Vue from "vue";
import { instance } from "./api/instance.js";
import ExampleComponent from "./components/ExampleComponent.vue";
import PostsComponent from "./components/PostsComponent.vue";

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below

// Use API
Vue.prototype.$http = instance;

// Enable to use Vue.js
var vue = new Vue({
  el: "#app",
  components: {
    "example-component": ExampleComponent,
    "posts-component": PostsComponent
  },
  data: {
  	menu_active: false,
    name: "Test"
  },
  mounted() {
    console.log("Running Vue.js");
  },
  methods: {
  	toggle_menu: function() {
  		this.menu_active = !this.menu_active;
  	}
  }
});


(function($) {
    $(document).ready(function() { // Loaded when DOM is ready
        console.log("Running jQuery");
    });
})( jQuery );
